import { Injectable } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private socket$: WebSocketSubject<any>;

  public connect(url: string): void {
    this.socket$ = webSocket(url);

    this.socket$.subscribe(
      msg => console.log('message received: ', msg), // Called whenever there is a message from the server.
      err => console.log(err), // Called if at any point WebSocket API signals some kind of error.
      () => console.log('complete') // Called when connection is closed (for whatever reason).
    );
  }

  public sendMessage(msg: any): void {
    this.socket$.next(msg);
  }

  public close(): void {
    this.socket$.complete();
  }
}
